export interface BotDetailGateInput {
    /** The bot entity for this botId, if it is present in the store (from any fetch). */
    bot: unknown;
    /** Has THIS view's own fetch for the current botId completed (resolved or errored)? */
    initialFetchDone: boolean;
}

export type BotDetailGateState = 'loading' | 'not-found' | 'ready';

/**
 * Decides what the bot-detail page renders.
 *
 * It depends ONLY on this bot's own load state — deliberately NOT on the global
 * DBBotReducer / DBBotDeploymentReducer `itemsLoading` flags. Those flags are
 * toggled by unrelated shell fetches (notably the sidebar's all-bots
 * `hasLegacyBots` fetch). Gating the whole page on them caused the #433
 * infinite remount/refetch loop: the shell fetch flipped the global flag, the
 * page swapped render branches and remounted its AppView shell, the remounted
 * shell re-fetched all bots, which re-flipped the flag — an endless spinner.
 *
 * Present bot wins immediately (it may arrive via the shell's all-bots fetch
 * before our own find resolves); otherwise we show the spinner until our first
 * fetch settles, then not-found.
 */
export function botDetailGateState({ bot, initialFetchDone }: BotDetailGateInput): BotDetailGateState {
    if (bot) return 'ready';
    if (!initialFetchDone) return 'loading';
    return 'not-found';
}
